import React from 'react'
import PropTypes from 'prop-types'
import { Input as AntInput } from 'antd'
import './input.scss'

const { TextArea: AntTextArea } = AntInput

const Input = ({
  type = 'text',
  value,
  defaultValue,
  placeholder,
  disabled = false,
  readOnly = false,
  status,
  prefix,
  suffix,
  addonBefore,
  addonAfter,
  onChange,
  onPressEnter,
  className = '',
  ...props
}) => {
  const inputClass = `app-input ${className}`

  // Filter status prop to include only valid values
  const statusProp = status === 'error' || status === 'warning' ? { status } : {}

  if (type === 'textarea') {
    return (
      <AntTextArea
        value={value}
        defaultValue={defaultValue}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        onChange={onChange}
        className={`${inputClass} app-textarea`}
        {...statusProp}
        {...props} // Spread remaining props
      />
    )
  }

  return (
    <AntInput
      type={type}
      value={value}
      defaultValue={defaultValue}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readOnly}
      prefix={prefix}
      suffix={suffix}
      addonBefore={addonBefore}
      addonAfter={addonAfter}
      onChange={onChange}
      onPressEnter={onPressEnter}
      className={inputClass}
      {...statusProp}
      {...props} // Spread remaining props
    />
  )
}

Input.propTypes = {
  type: PropTypes.oneOf(['text', 'password', 'number', 'textarea']),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  status: PropTypes.oneOf(['error', 'warning', '']), // Allow empty string as a valid status
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  addonBefore: PropTypes.node,
  addonAfter: PropTypes.node,
  onChange: PropTypes.func,
  onPressEnter: PropTypes.func,
  className: PropTypes.string
}

export default Input
